// api/services/performance.ts
import { handleRequest } from '@/api';
import type { EntityPerformanceResponse } from '@/types/performance';

/**
 * The viewer's own entity's scorecard. The backend scopes it, so nothing is passed. No error
 * toast: the page says what went wrong in place, where the reader is already looking.
 */
export const getEntityPerformance = (signal?: AbortSignal): Promise<EntityPerformanceResponse> =>
    handleRequest<EntityPerformanceResponse>('get', '/performance/entity', { signal }, null, false, false);
